import type { TCommentBase, TError, TUpdateComment } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from '../../axios';
import { getPostQueryKey } from '../posts/get-post';
import { getPostCommentsQueryKey } from './get-comments';

/**
 * Hook to update a comment
 * Only the comment author can update their own comments
 *
 * @param postId - Post ID (UUID) the comment belongs to
 * @param commentId - Comment ID (UUID) to update
 */
export const useUpdateComment = (postId: string, commentId: string) => {
  const queryClient = useQueryClient();

  return useMutation<TCommentBase, TError, TUpdateComment>({
    mutationFn: async data => {
      const res = await axios.patch<TCommentBase>(`/community-hub/comments/${commentId}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getPostCommentsQueryKey(postId) });
      queryClient.invalidateQueries({ queryKey: getPostQueryKey(postId) });
    },
  });
};
